import ColumnId from './ColumnId';
import translate from '~/zf/frontend/common/localization/translate';
import SettingsOptionRenderer from './SettingsOptionRenderer';
import VcomProvider from '../../../VcomProvider';

function getSettingsColumnOptions(hasMonitoringAccess) {
  const settingColumns = [
    {
      value: ColumnId.LEISTUNG,
      text: translate('performanceOverview.POWER_PEAK'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.E_Z_EVU,
      text: translate('performanceOverview.YIELD'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.E_N,
      text: translate('performanceOverview.SPECIFIC_YIELD'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.PR,
      text: translate('performanceOverview.PR'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.G_M,
      text: translate('performanceOverview.IRRADIANCE'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.G_M_SAT,
      text: translate('performanceOverview.IRRADIANCE_SATELLITE'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.VFG,
      text: translate('performanceOverview.AVAILABILITY'),
      renderer: SettingsOptionRenderer.SETTINGS_UNAVAILABLE_TODAY,
    },
    {
      value: ColumnId.E_SIM_DIFF_PERC,
      text: translate('performanceOverview.DEVIATION_RATED_ACTUAL'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.E_SIM,
      text: translate('performanceOverview.SIMULATION'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.DATAINPUT,
      text: translate('performanceOverview.DATA_INPUT'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.LAST_DATAINPUT_LOCALTIME,
      text: translate('portal.TX_LATEST_DATAINPUT'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.EPI,
      text: translate('performanceOverview.EPI'),
      renderer: SettingsOptionRenderer.SETTINGS_UNAVAILABLE_TODAY,
    },
    {
      value: ColumnId.SPECIFIC_YIELD_SIMULATED,
      text: translate('performanceOverview.SPECIFIC_YIELD_SIMULATED'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
  ];
  const monitoringAccessColumns = [
    {
      value: ColumnId.alarmsToday,
      text: translate('performanceOverview.ALARMS_TODAY'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.alarmsYesterday,
      text: translate('performanceOverview.ALARMS_YESTERDAY'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
    {
      value: ColumnId.alarmsLastWeek,
      text: translate('performanceOverview.ALARMS_LAST_SEVEN_DAYS'),
      renderer: SettingsOptionRenderer.SETTINGS,
    },
  ];

  if (!VcomProvider.isRegionChina) {
    // eslint-disable-next-line fp/no-mutating-methods
    monitoringAccessColumns.push(
      {
        value: ColumnId.INVERTER_EVALUATION,
        text: translate('performanceOverview.INVERTER_EVALUATION'),
        renderer: SettingsOptionRenderer.SETTINGS_ONLY_TODAY,
      },
    );
  }

  if (hasMonitoringAccess) {
    return [...settingColumns, ...monitoringAccessColumns];
  }
  return settingColumns;
}

export default {
  getSettingsColumnOptions,
};
